import { List, ListItem, ListItemText } from "@mui/material";
import { IconButton, ListItemIcon, StatusGlyph } from "@outpave/ds";
import { HugeiconsIcon } from "@hugeicons/react";
import { Edit02Icon, Delete02Icon } from "@hugeicons-pro/core-stroke-rounded";
import { useTranslation } from "react-i18next";
import { Inline } from "components/layout/reusableLayouts";
import { User } from "hooks/useAddUpdateUser";
import { fullName } from "utils/fullName";

interface OwnersListProps {
  owners: User[];
  onEdit: (owner: User) => void;
  onRemove: (owner: User) => void;
}

const OwnersList = (props: OwnersListProps) => {
  const { owners, onRemove, onEdit } = props;
  const { t } = useTranslation();

  return (
    <List disablePadding>
      {owners.map((owner) => {
        const name = fullName(owner);
        return (
          <ListItem
            key={owner.id}
            divider
            disableGutters
            secondaryAction={
              <Inline gap="var(--space-1)" wrap={false}>
                <IconButton
                  variant="ghost"
                  size="small"
                  aria-label={`${t("Edit")} ${name}`}
                  onClick={() => onEdit(owner)}
                >
                  <HugeiconsIcon
                    icon={Edit02Icon}
                    size={20}
                    color="currentColor"
                  />
                </IconButton>
                <IconButton
                  variant="ghost"
                  size="small"
                  aria-label={`${t("Remove")} ${name}`}
                  onClick={() => onRemove(owner)}
                >
                  <HugeiconsIcon
                    icon={Delete02Icon}
                    size={20}
                    color="currentColor"
                  />
                </IconButton>
              </Inline>
            }
          >
            {owner.isValidated !== undefined && (
              <ListItemIcon>
                <StatusGlyph
                  status={owner.isValidated ? "complete" : "failed"}
                  tone={owner.isValidated ? "positive" : "negative"}
                />
              </ListItemIcon>
            )}
            <ListItemText primary={name} secondary={owner.email} />
          </ListItem>
        );
      })}
    </List>
  );
};

export default OwnersList;
